import { collection, query, where, onSnapshot } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

import { brand } from "../constants/brandVariables/brandVariables";
import { Challenge } from "./../models/challenge.model";
import { firestore } from "../api/firebaseConfig";

export const useGetOngoingChallenge = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Challenge | null>(null);
  const [error, setError] = useState<string>();
  const { slug } = useParams();

  useEffect(() => {
    const challengesRef = collection(
      firestore,
      "challenges",
      brand.tenantId,
      "records"
    );

    const q = query(
      challengesRef,
      where("gameType", "==", brand.gameType),
      where("status", "==", "ongoing")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        let challenge = snapshot.docs.map((doc) => doc.data())[0] as
          | Challenge
          | undefined;

        if (brand.gameStyle === "racedays") {
          challenge = snapshot.docs
            .filter((challenge) => {
              const mapModes =
                challenge.data()?.challengeAdditionalData?.mapModes;
              return mapModes && mapModes.includes(slug);
            })[0]
            ?.data() as Challenge | undefined;
        }

        setData(challenge ?? null);
        setLoading(false);
      },
      (error) => {
        console.error("Error listening to ongoing challenge:", error);
        setError(`Error listening to ongoing challenge data!`);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [slug]);

  return { loading, data, error };
};
